'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = supportedKeyframes;

var _prefix = require('./prefix');

var _prefix2 = _interopRequireDefault(_prefix);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 * Test if a keyframe at-rule should be prefixed or not
 *
 * @param {String} vendor prefix string for the current browser.
 * @return {String}
 * @api public
 */

function supportedKeyframes(key) {
  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
  if (key[1] === '-') return key;
  // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
  // https://caniuse.com/#search=keyframes
  if (_prefix2['default'].js === 'ms') return key;
  return '@' + _prefix2['default'].css + 'keyframes' + key.substr(10);
}


//////////////////
// WEBPACK FOOTER
// ./~/css-vendor/lib/supported-keyframes.js
// module id = 4
// module chunks = 0